import { DialogContent, DialogTitle } from '@mui/material';
import {
  ComplianceChecklistItemStatus,
  ComplianceRejectedEvent,
  ComplianceRequiredEvent,
  ComplianceValidatedEvent,
  SessionEventComplianceType,
  SessionEventsFieldsFragment,
  SessionSummaryFieldsFragment,
} from '../../../../../../../../../../../generated/core-api/graphql-react-query';
import TopicTag from '../../../../../../CommandPage/Components/CommandItem/Components/TopicTag/TopicTag';
import ComplianceTag from './Components/ComplianceTag';
import RejectedEventItem from './Components/RejectedEventItem';
import RequiredEventItem from './Components/RequiredEventItem';
import ValidatedEventItem from './Components/ValidatedEventItem';
import StyledDialog from './styles';

function getComplianceEventsForTopic(
  events: SessionEventsFieldsFragment[] | undefined,
  topicLower: string | null,
) {
  const requiredEvent = events?.find((event): event is ComplianceRequiredEvent => event.__typename === SessionEventComplianceType.ComplianceRequiredEvent && event.topicTextLower === topicLower);
  const validatedEvent = events?.find((event): event is ComplianceValidatedEvent => event.__typename === SessionEventComplianceType.ComplianceValidatedEvent && event.topicTextLower === topicLower);
  const rejectedEvent = events?.find((event): event is ComplianceRejectedEvent => event.__typename === SessionEventComplianceType.ComplianceRejectedEvent && event.topicTextLower === topicLower);
  return {
    required: requiredEvent,
    validated: validatedEvent,
    rejected: rejectedEvent,
  };
}

interface ComplianceTopicDetailsDialogProps {
  open: { text: string; color: string; textLower: string } | null;
  session: SessionSummaryFieldsFragment;
  onClose: () => void;
  status: ComplianceChecklistItemStatus;
}

export default function ComplianceTopicDetailsDialog({
  session,
  onClose,
  open: topic,
  status,
}: ComplianceTopicDetailsDialogProps) {
  const {
    required, validated, rejected,
  } = getComplianceEventsForTopic(session.sessionEvents, topic?.textLower);
  return (
    <StyledDialog hideBackdrop maxWidth="sm" fullWidth open={!!topic} onClose={onClose}>
      <DialogTitle>
        <ComplianceTag status={status} />
        {topic && <TopicTag topic={topic.text} color={topic.color} />}
      </DialogTitle>

      <DialogContent>
        {required && (
          <RequiredEventItem sessionDate={session.date} sessionEvent={required} />
        )}
        {validated && <ValidatedEventItem sessionEvent={validated} />}
        {rejected && <RejectedEventItem sessionEvent={rejected} />}
      </DialogContent>
    </StyledDialog>
  );
}
